import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECT_STAKEHOLDER_FEATURE_KEY,
  ProjectStakeholderState,
  ProjectStakeholderPartialState,
  projectStakeholderAdapter,
} from './project-stakeholder.reducer';
import { ProjectStakeholderDto } from '@cradua/data';

// Lookup the 'ProjectStakeholder' feature state managed by NgRx
export const getProjectStakeholderState = createFeatureSelector<
  ProjectStakeholderPartialState,
  ProjectStakeholderState
>(PROJECT_STAKEHOLDER_FEATURE_KEY);

const { selectAll, selectEntities } = projectStakeholderAdapter.getSelectors();

export const getProjectStakeholderLoaded = createSelector(
  getProjectStakeholderState,
  (state: ProjectStakeholderState) => state.loaded
);

export const getProjectStakeholderError = createSelector(
  getProjectStakeholderState,
  (state: ProjectStakeholderState) => state.error
);

export const loadingProjectStakeholder = createSelector(
  getProjectStakeholderState,
  (state: ProjectStakeholderState) => state.loaded
);

export const getAllProjectStakeholder = createSelector(
  getProjectStakeholderState,
  (state: ProjectStakeholderState) => selectAll(state)
);

export const getProjectStakeholderEntities = createSelector(
  getProjectStakeholderState,
  (state: ProjectStakeholderState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProjectStakeholderState,
  (state: ProjectStakeholderState) => state.selectedProjectStakeholderId
);

export const getSelected = createSelector(
  getProjectStakeholderEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProjectStakeholder,
  getSelectedId,
  (users: ProjectStakeholderDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.StakeholderName.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.StakeholderRole.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
